import PermissionsStore from './PermissionsStore'

export default PermissionsStore
